export class HistoricoSwapModel {
  constructor(
    public readonly id: number,
    public readonly dataHora: string,
    public readonly descricao: string,
    public readonly usuario: string,
    public readonly tipo: string,
  ) {}

  static fromJson(json: any): HistoricoSwapModel {
    return new HistoricoSwapModel(
      json.id ?? 0,
      json.dataHora || json.data || '',
      json.descricao || json.mensagem || '',
      json.usuario || json.login || '',
      json.tipo || 'INFO',
    );
  }

  get dataFormatada(): string {
    if (!this.dataHora) return '';
    try {
      const date = new Date(this.dataHora);
      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return this.dataHora;
    }
  }
}
